import { QuestWithConfig, Owner } from 'state/vvsgotchi/models'
import { formatNumber } from 'utils/formatBalance'
import { ContextApi } from 'contexts/Localization/types'

export const questSymbolId = (symbol: string) => {
  return symbol.toLowerCase().replace(/_| /, '-')
}

export const getExpBrief = (quest: QuestWithConfig, owner: Owner, t: ContextApi['t']) => {
  if (quest.variableExpRules) {
    return t('Variable EXP')
  }
  if (quest.exp > 0) {
    return `+${formatNumber(quest.exp * (owner?.expMultiplier ?? 1), 0)}`
  }

  return null
}
